import {
  Card,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography,
  Switch,
  ToggleButtonGroup,
  ToggleButton,
  Button,
} from "@mui/material";

import { useAppDispatch, useAppSelector } from "Hooks/useRedux";

import {
  changeCameraType,
  togglePointwiseShow,
  toggleVisibility,
  changeCameraStarTypes,
  changeCameraShowType,
} from "Redux/cameraSlice";
import { useState } from "react";
import { CAMERA_TYPES } from "Constants/Stations";
import { changeDataForPost, createTrafficAnalysisStarUrl } from "Redux/starSlice";
import MenuButton from "./Button";

export default function Camera() {
  const dispatch = useAppDispatch();

  const { cameraTypes, visible, pointwiseShow, cameraStarTypes, cameraShowType } = useAppSelector((state) => state.camera);

  const label = { inputProps: { "aria-label": "Switch demo" } };

  const handleMarkerPointWise = () => {
    dispatch(togglePointwiseShow());
  };

  const handleCameraShowType = (event: React.MouseEvent<HTMLElement>, newMode: string[]) => {
    if (newMode.length) {
      dispatch(changeCameraShowType(newMode));
    }
  };

  const handleSwitch = () => {
    dispatch(toggleVisibility());

    dispatch(
      createTrafficAnalysisStarUrl([
        `https://report.baarestan.ir:8080/dashboard/publicview?dashboardid=25c862a7-9341-454d-b113-10c77f41d1c6&paramvalues={"a9a44bc5-249d-abd1-278e-5ab194462f4f":[{"Value":[],"FromColumn":false,"SelectedField":null}]}`,
        `https://report.baarestan.ir:8080/dashboard/publicview?dashboardid=e6543d83-0368-4915-93c6-175e6998ed78&paramvalues={"a9a44bc5-249d-abd1-278e-5ab194462f4f":[{"Value":[],"FromColumn":false,"SelectedField":null}]}`,
      ])
    );
  };

  const handleClick = (type: string, starType: string) => {
    if (cameraStarTypes.includes(starType)) {
      const newCameraStarTypes = cameraStarTypes.filter((c) => c !== starType);
      const urlValue = newCameraStarTypes.map((t) => `{"$type":"WebParameterValue","Id":"${t}","Value":"${t}"}`);
      dispatch(
        createTrafficAnalysisStarUrl([
          `https://report.baarestan.ir:8080/dashboard/publicview?dashboardid=25c862a7-9341-454d-b113-10c77f41d1c6&paramvalues={"a9a44bc5-249d-abd1-278e-5ab194462f4f":[{"Value":[${urlValue}],"FromColumn":false,"SelectedField":null}]}`,
          `https://report.baarestan.ir:8080/dashboard/publicview?dashboardid=e6543d83-0368-4915-93c6-175e6998ed78&paramvalues={"a9a44bc5-249d-abd1-278e-5ab194462f4f":[{"Value":[${urlValue}],"FromColumn":false,"SelectedField":null}]}`,
        ])
      );
      dispatch(changeCameraStarTypes(newCameraStarTypes));
    } else {
      const urlValue = [...cameraStarTypes, starType].map((t) => `{"$type":"WebParameterValue","Id":"${t}","Value":"${t}"}`);
      dispatch(
        createTrafficAnalysisStarUrl([
          `https://report.baarestan.ir:8080/dashboard/publicview?dashboardid=25c862a7-9341-454d-b113-10c77f41d1c6&paramvalues={"a9a44bc5-249d-abd1-278e-5ab194462f4f":[{"Value":[${urlValue}],"FromColumn":false,"SelectedField":null}]}`,
          `https://report.baarestan.ir:8080/dashboard/publicview?dashboardid=e6543d83-0368-4915-93c6-175e6998ed78&paramvalues={"a9a44bc5-249d-abd1-278e-5ab194462f4f":[{"Value":[${urlValue}],"FromColumn":false,"SelectedField":null}]}`,
        ])
      );
      dispatch(changeCameraStarTypes([...cameraStarTypes, starType]));
    }
    dispatch(changeCameraType(type));
  };

  return (
    <Card sx={{ p: 1.5 }}>
      <Stack spacing={2} direction="row" sx={{ justifyContent: "space-between" }}>
        <ToggleButtonGroup value={cameraShowType} onChange={handleCameraShowType} aria-label="camera-show-type">
          <ToggleButton
            value="1"
            aria-label="camera-mode-1"
            style={{
              width: "80px",
              height: "56px",
              backgroundColor: cameraShowType.includes("1") ? "#4754CA" : "",
              color: cameraShowType.includes("1") ? "#fff" : "",
            }}
          >
            فعال
          </ToggleButton>
          <ToggleButton
            value="0"
            aria-label="camera-mode-0"
            style={{
              width: "80px",
              height: "56px",
              backgroundColor: cameraShowType.includes("0") ? "#4754CA" : "",
              color: cameraShowType.includes("0") ? "#fff" : "",
            }}
          >
            غیرفعال
          </ToggleButton>
        </ToggleButtonGroup>
        <Stack direction="row" sx={{ justifyContent: "space-between" }}>
          <Button onClick={handleMarkerPointWise} variant={pointwiseShow ? "contained" : "light"} style={{ marginRight: "10px" }}>
            نمایش نقطه ای
          </Button>
        </Stack>
        {CAMERA_TYPES.map((camera) => (
          <MenuButton
            isActive={cameraTypes.includes(camera.type)}
            onClick={() => handleClick(camera.type, camera.text)}
            title={camera.text}
          >
            {!cameraTypes.includes(camera.type) ? (
              <img src={camera.imgSrc} alt="test" style={{ width: "28px" }} />
            ) : (
              <img src={camera.whiteImgSrc} alt="test" style={{ width: "28px" }} />
            )}
          </MenuButton>
        ))}
        <Stack direction="row" sx={{ justifyContent: "space-between", alignItems: "center" }}>
          <Typography sx={{ fontSize: "18px !important", mb: "0 !important" }}>نمایش</Typography>
          <Switch {...label} onChange={handleSwitch} checked={visible} />
        </Stack>
      </Stack>
    </Card>
  );
}
